export function initClock() {
    const clock = document.querySelector('.js-b-footer__clock')
    if (!clock) return

    const updateClock = () => {
        const now = new Date()
        const options = {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            timeZone: 'Europe/Madrid',
            hour12: false,
        }
        clock.textContent = new Intl.DateTimeFormat('es-ES', options).format(now)
    }

    updateClock()
    setInterval(updateClock, 1000)
}
